import { render, staticRenderFns } from "./FirmIntroPage.vue?vue&type=template&id=5667b6ff&scoped=true"
import script from "./FirmIntroPage.vue?vue&type=script&lang=js"
export * from "./FirmIntroPage.vue?vue&type=script&lang=js"
import style0 from "./FirmIntroPage.vue?vue&type=style&index=0&id=5667b6ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5667b6ff",
  null
  
)

export default component.exports